import React from "react";
import { TimelineItem } from "./TimelineItem";
import "../../../css/MSAProgramme/Timeline/Timeline.css";

import BasicTrainingImg from "../../../assets/images/Timeline/basic_training.jpg";
import AdvTrainingImg from "../../../assets/images/Timeline/advanced_training.jpg";
import EmployerEveningImg from "../../../assets/images/Timeline/Employer_evening.jpg";
import InternshipImg from "../../../assets/images/Timeline/placements.jpg";
import MSLearnImg from "../../../assets/images/mslearn/intro-to-azure-virtual-machines.svg";

const timelineTitle = "2026 Programme Schedule";

// If you include more content here, make sure to check whether the timeline bar reaches to the bottom. Timeline bar was not done very well.
// Edit the timeline bar length in ./Timeline.css
const timelineContent = [
  {
    daterange: "April - May",
    heading: "Phase 1 - Microsoft Learn Modules",
    paragraph:
      "Students will be provided with resources from Microsoft Learn that have been curated by the MSA team and learn the fundamentals of Software Development and Data Science!",
    image: MSLearnImg,
  },
  {
    daterange: "June - August",
    heading: "Phase 2 - Technical",
    paragraph:
      "Phase 2 is where students transition from theory to practice, applying their foundational knowledge from Phase 1 to real-world projects. Software development participants will build a complete website using React, TypeScript, .NET, and C#, while data science students will tackle a full ML project, covering EDA, data preprocessing, and deep learning.",
    image: BasicTrainingImg,
  },
  {
    daterange: "September - October",
    heading: "Phase 3 - Soft Skills Enchancement",
    paragraph:
      "Phase 3 boosts soft skills, emphasizing soft skills. interview techniques. Refining their interview skills and receive feedback on writing and presentations, ensuring they're ready to impress employers.",
    image: AdvTrainingImg,
  },
  {
    daterange: "November",
    heading: "Employers' Evening",
    paragraph:
      "Students who have passed all phases to a high standard may have the opportunity to meet with employers and discuss summer work placements.",
    image: EmployerEveningImg,
  },
  {
    daterange: "November - February",
    heading: "Work Placement",
    paragraph: "If placed with an employer, Students will work on innovative projects with employers throughout the summer.",
    image: InternshipImg,
  },
];

export default function Timeline() {
  return (
    <div className="container-fluid bg-light no-mt pt-5">
      <div className="row">
        <div className="col-lg-12 text-center">
          <h1>{timelineTitle}</h1>
        </div>
      </div>
      <div className="row col-lg-12 pt-5 justify-content-md-center">
        <div className="">
          <ul className="timeline">
            {timelineContent.map((contents, i) => {
              return (
                <TimelineItem key={i + 1} index={i + 1} content={contents} />
              );
            })}
          </ul>
        </div>
      </div>
    </div>
  );
}
